import { ArrowUpRight } from "lucide-react";
import { track } from "@/lib/api";
import { Waitlist } from "@/components/site/Waitlist";

const SVG_GLYPHS = {
  spottros: <><circle cx="32" cy="32" r="20" className="accent" /><path d="M8 34h13l5-12 8 22 6-16 4 6h12" /></>,
  jurisos: <path d="M10 24 32 12l22 12M15 26v22M25 26v22M39 26v22M49 26v22M8 52h48" />,
  procureos: <><path d="M32 10 54 21v22L32 54 10 43V21z" /><path d="M10 21l22 11 22-11M32 32v22" className="accent" /></>,
};

const Glyph = ({ slug }) => (
  <div className="product-glyph" aria-hidden="true">
    <div className="halo" />
    {slug === "builtos" && <div className="glyph-building" />}
    {slug === "resolveos" && <div className="glyph-resolve" />}
    {SVG_GLYPHS[slug] && <svg viewBox="0 0 64 64" className="glyph-svg">{SVG_GLYPHS[slug]}</svg>}
  </div>
);

const Name = ({ name }) => (name.endsWith("OS") ? <>{name.slice(0, -2)}<span>OS</span></> : name);

const hostOf = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
};

export const ProductModule = ({ p, index }) => {
  const live = p.status === "Live";
  const host = hostOf(p.url);
  return (
    <article className={`product-module ${index % 2 ? "right" : "left"}`} aria-labelledby={`${p.slug}-name`} data-testid={`product-card-${p.slug}`}>
      <div className="module-top">
        <span>SNT / Platform {String(index + 1).padStart(2, "0")}</span>
        <span className={`status-badge ${live ? "status-live" : "status-soon"}`} data-testid={`product-status-${p.slug}`}>{p.status}</span>
      </div>
      <Glyph slug={p.slug} />
      <h3 id={`${p.slug}-name`} className="product-name"><Name name={p.name} /></h3>
      <p className="product-tagline" data-testid={`product-tagline-${p.slug}`}>{p.tagline}</p>
      <p className="product-desc" data-testid={`product-description-${p.slug}`}>{p.description}</p>
      {p.status === "Coming Soon" ? <Waitlist p={p} /> : (
        <div className="module-foot">
          <span className="product-domain">{host || "Launching soon"}</span>
          {p.url && (
            <a className="btn" href={p.url} target="_blank" rel="noopener noreferrer" onClick={() => track("cta_click", { cta: `visit-${p.slug}` })}
              aria-label={`Visit ${p.name} at ${host} (opens in new tab)`} data-testid={`product-visit-${p.slug}`}>
              Visit <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
          )}
        </div>
      )}
    </article>
  );
};
